export var SELECT_ALL_INDEX = -1;